import React, { useCallback, useState, useEffect } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Divider from '@mui/material/Divider'

import Daily, { DailyEventObjectInputSettingsUpdated } from '@daily-co/daily-js';
import { useInputSettings } from '@daily-co/daily-react'

import BackgroundThumbnail from './BackgroundThumbnail';
import { useSessionContext } from '../../contexts/SessionContext';

import { useBackgroundModalStyles } from './styles'

const BackgroundOptionsDialog = ({ 
  open, 
  onClose 
}: { 
  open: boolean; 
  onClose: () => void 
}) => {
  const classes = useBackgroundModalStyles()
  const { backgroundSettings } = useSessionContext()
  const [ errorMessage, setErrorMessage ] = useState<string | null>('')

  const { updateInputSettings, errorMsg, inputSettings } = useInputSettings({
    onError: useCallback(() => {
      console.log('::::errorMsg:', errorMsg)
      setErrorMessage(errorMsg)
    }, []),

    onInputSettingsUpdated: useCallback(
      (event: DailyEventObjectInputSettingsUpdated) => {
        console.log(
          '::::Input settings updated event.inputSettings?.video?.processor:',
          event.inputSettings?.video?.processor
        )
      },
      []
    ),
  })

  useEffect(() => {
    if (backgroundSettings.index === 1) {
      console.log(`::::enableBackgroundBlur supportedBrowser().supportsVideoProcessing: ${Daily.supportedBrowser().supportsVideoProcessing}`)
      updateInputSettings({
        video: {
          processor: {
            type: 'background-blur',
            config: { strength: 0.75 },
          },
        },
      })
    }
    else {
      console.log('::::disableBackgroundBlur...')
      updateInputSettings({
        video: {
          processor: {
            type: 'none'
          }
        },
      })
    }

  }, [backgroundSettings])



  // this code is incomplete, need to add a list of background images
  const imageNames:any = []
  const images:any = []




  return (
    <Dialog open={open} onClose={onClose} sx={{ paper: classes.paper }}>
      <DialogTitle>Connection Settings</DialogTitle>
      <Divider />
      <DialogContent sx={classes.container}>

        <Box sx={classes.thumbnailContainer}>
          <BackgroundThumbnail thumbnail={'none'} index={-1} name={'None'} />
          <BackgroundThumbnail thumbnail={'blur'} index={1} name={'Blur'} />
          {images.map((image:any, index:number) => (
            <BackgroundThumbnail
              thumbnail={'image'}
              name={imageNames[index]}
              index={index}
              imagePath={image}
              key={image}
            />
          ))}
        </Box>

      </DialogContent>
      <Divider />
      <DialogActions>
        <Button sx={classes.button} color="primary" variant="contained" onClick={onClose}>
          Done
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default BackgroundOptionsDialog